import React from 'react';
import Wrapper from '../components/global/Wrapper';
import SettingSteps from '../components/SettingPage/SettingSteps';

const SettingPaymentPage = () => {
  return (
    <Wrapper className=' space-y-3 md:space-y-8  !mr-0'>
      <div className=' md:block  xl:flex '>
        <div className='min-w-[200px] hidden  md:hidden lg:hidden xl:flex'>
          <SettingSteps />
        </div>
        <div className='flex-2 md:px-[35px] pt-[12px] md:pt-12  md:w-[100%] lg:w-[70%] xl:w-[70%] m-auto'>
          SettingPaymentPage
        </div>
      </div>
    </Wrapper>
  );
};

export default SettingPaymentPage;
